import { useContext, useEffect } from 'react';
import { useHistory } from 'react-router';

import { VERIFICATION_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsDocumentVerification';
import { isUndefined } from 'Utilities/helpers';

import { DOCUMENT_CAPTURE_ROUTE_NAMES } from '../DocumentCapture.helpers';
import { DocumentCaptureConfirmationProgressContext } from '../DocumentCaptureContexts';

export const useBankDetailsRedirect = () => {
  const history = useHistory();
  const { progress } = useContext(DocumentCaptureConfirmationProgressContext) || {};

  const { bankDetailsAdded, bankDetailsReviewFailed } = progress || {};
  const isDataLoaded = !isUndefined(bankDetailsAdded);
  const bankDetailsIncomplete = isDataLoaded && (!bankDetailsAdded || bankDetailsReviewFailed);

  useEffect(() => {
    if (isDataLoaded) {
      if (bankDetailsIncomplete) {
        history.push(DOCUMENT_CAPTURE_ROUTE_NAMES.ADD_BANK_DETAILS);
      } else {
        VERIFICATION_ANALYTICS_EVENTS.DOCS_IN_REVIEW({ label: 'incode-review' });
      }
    }
  }, [bankDetailsIncomplete, history, isDataLoaded]);

  return { bankDetailsIncomplete, isDataLoaded };
};
